import { GetRichTextEditorAgentPayload } from 'app/shared/components/RichTextEditor/requests';

const BASE = ['rich_text_editor_agent'];

export const RICH_TEXT_EDITOR_QUERY_KEYS = {
  getFetchAllRichTextEditorAgents: (body: GetRichTextEditorAgentPayload) =>
    [...BASE, body] as const,
};
